import { TextField } from '@mui/material';
import { Component } from 'react';

export default class QtdInput extends Component {
    render() {
        const value = this.props.value || 0; // Define um valor padrão se value for undefined
        return (
            <TextField
                {...this.props.props}
                type="number"
                inputProps={{ min: 0 }}
                sx={this.props.sx}
                error={this.props.error === true}
                helperText={this.props.error === true ? "Preenche isso" : null}
                size="small"
                variant="outlined"
                name="codfil"
                value={value}
                onChange={e => this.props.onChange ? this.props.onChange(e.target.value) : {}} />
        );
    }
}